import styled from 'styled-components';

const ContentWrapper = styled.div`
  padding-bottom: 70px; /* Space for the navigation */
  overflow-y: auto;
  height: calc(100vh - 70px); /* Full height minus the navigation bar */
`;

export default ContentWrapper;
